//
// Overlay.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "./AbstractOverlay";
import "../axis/XAxisPosition";
import "../axis/YAxisPosition";
import "./ContributeOffsets";

var Overlay = createModule("gtl::Overlay", ["commons::PropertyOwner","commons::BaseModel","gtl::GTLModel","gtl::RendererModel","gtl::DataRendererModel","gtl::DataVisualization","gtl::AbstractOverlay"], EventDispatcher, [
    ,
    {
        yAxis: 4,
        xAxis: 4,
        contributeOffsets: 1,
        primary: 2,
    },
    ,
    ,
    ,
    ,
    ,
]);
export default Overlay;
